var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('app-banner',{attrs:{"role":"banner"}}),_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[(_vm.connecting)?_c('div',{key:"connecting",staticClass:"transition-root"},[_c('div',{staticClass:"row"},[_c('loading-indicator',[_vm._v("Forbinder..")])],1)]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }